var FeedbackView, ModalView, W, mediator, template,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

ModalView = require('base/views/modal_view');

W = require('when');

template = require('./templates/feedback');

mediator = require('mediator');

module.exports = FeedbackView = (function(_super) {
  __extends(FeedbackView, _super);

  function FeedbackView() {
    return FeedbackView.__super__.constructor.apply(this, arguments);
  }

  FeedbackView.prototype.className = 'feedback-view';

  FeedbackView.prototype.template = template;

  FeedbackView.prototype.title = $.t('feedback.title');

  FeedbackView.prototype.initialize = function() {
    FeedbackView.__super__.initialize.apply(this, arguments);
    this.delegate('click', 'button.cancel', this.dispose);
    return this.delegate('click', 'button.send', this._send);
  };

  FeedbackView.prototype._send = function() {
    var takeScreenshot, text, type;
    text = this.$('.text').val();
    type = this.$('.type').val();
    takeScreenshot = this.$('.attach-screenshot').prop('checked');
    this.dispose();
    return this.dialog.on('destroy', (function(_this) {
      return function() {
        return _this._getScreenshot(takeScreenshot).then(function(screenshot) {
          var _ref;
          return mediator.user.getRequests().create({
            type: 'feedback',
            email: mediator.user.get('email'),
            project: (_ref = mediator.project) != null ? _ref.id : void 0,
            feedbackType: type,
            feedbackText: text,
            platformInfo: platform.description,
            screenshot: screenshot
          });
        }).then(function() {
          return mediator.dialogs.success($.t('feedback.thanks'));
        }, function(error) {
          return mediator.fatalError(error);
        });
      };
    })(this));
  };

  FeedbackView.prototype._getScreenshot = function(takeScreenshot) {
    if (!takeScreenshot) {
      return W.resolve();
    }
    return W.promise(function(resolve) {
      return html2canvas(document.body, {
        onrendered: function(canvas) {
          return resolve(canvas.toDataURL());
        }
      });
    });
  };

  return FeedbackView;

})(ModalView);
